const colors = {
    important: "#04C484",
    accent: "#eeeeee",
    darkerImportant: "#327d68",
    main: "#393e46",
}
export default colors